import * as utils from './utils';
let scrollPosition;
let lastOpenedPopup = null;

$(function () {
    if (location.hash !== '') {
        $(`.js-popup[data-block='${location.hash.substr(1)}']`).addClass('is-show');
        scrollPosition = $(window).scrollTop();
    }

    $('body').on('click', '.js-popup-link', function (e) {
        e.preventDefault();
        let $this = $(this);
        let target = $this.attr('data-link');
        let href = $this.attr('data-href');
        let videoSrc = $this.attr('data-src');
        openPopup(target, href, videoSrc);
        if (typeof $this.data('scrollto') !== 'undefined') {
            setTimeout(function () {
                let form = $('.js-ajax-wrapper').find('form');
                if (form.length) {
                    form.find('input:not([type="hidden"])').first().focus();
                }
            }, 1500);
        }

        return false;
    });

    /*fetch("/viewcomponent/citypicker")
        .then(response => response.text())
        .then(data => {
            document.querySelector(".citypicker__container").innerHTML = data; 
            SB.initHeaderCityPicker();
        });*/
});

window.openPopup = function (target, href, videoSrc) {
    let $popup = $('.js-popup');
    const $elem = $('.js-popup[data-block="' + target + '"]');
    if ($elem.length === 0) {
        return;
    }
    $popup.removeClass('is-show');
    $elem.addClass('is-show');
    addBlur();

    if (utils.isMobile()) {
        utils.disablePageScroll()
    }

    scrollPosition = $(window).scrollTop();

    if (videoSrc) {
        let video = $elem.find('.js-iframe');
        video.attr('src', videoSrc);
    }

    scrollPosition = $(window).scrollTop();

    if (href) {
        let $jsPopup = $('.js-popup[data-block="' + target + '"]');
        history.pushState({}, '', href);
        $jsPopup.find('.js-ajax-wrapper').empty();
        getEventItem(href, $jsPopup);
        lastOpenedPopup = 'href';
    }
}

window.getEventItem = function (item, elem) {
    $.ajax({
        url: item,
        type: "GET",
        success: function (data) {
            if ($(data).length !== 0) {
                elem.find('.js-ajax-wrapper').html($(data).hide().fadeIn(1000));

                setTimeout(function () {
                    formValidate();
                    initSelect();
                    inputMask();
                    initSlider();
                    // initSelectInput();
                    // initSelectSearch();
                }, 1000);

            }
        }
    });
}

$('body').on('click', '.js-popup-close', function () {
    let $this = $(this);
    let $popup = $this.closest('.js-popup');
    utils.enablePageScroll();
    removeBlur();
    removeMainBlur();
    $popup.removeClass('is-show');
    $popup.find('.js-iframe').attr('src', '');
    if (scrollPosition !== "undefined") {
        $(window).scrollTop(scrollPosition);
        scrollPosition = undefined;
    }

    if (lastOpenedPopup === 'href') {
        history.back();
        $(window).scrollTop();
        lastOpenedPopup = null;
    }
});

//close modal-city 
$('.js-close-modal-city').on('click', function (e) {
    e.preventDefault();
    $('.js-modal-city').hide();
})